export default "__VITE_ASSET__28a758ab__"